import ReactPlayer from "react-player";
import React from "react";
import {useTranslation} from "react-i18next";

function VideoComponent_IndividualGames(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'videoComponentIndividualGames' });

    function getReactComponent(url) {
        return (
            <ReactPlayer
                url={url}
                controls height={200} width={250}
                light={'https://leela-online-videos.s3.eu-north-1.amazonaws.com/MainPage.png'}
                style={{marginTop: "12px"}}
            >
            </ReactPlayer>
        )
    }

    return (
        <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            overflow: "hidden"
        }}>
            <div style={{marginTop: "100px"}}><b>{t('creation')}</b></div>
            {getReactComponent("https://leela-online-videos.s3.eu-north-1.amazonaws.com/IndividualGame_create_small.mp4")}

            <div style={{marginTop: "100px"}}><b>{t('gamesList')}</b></div>
            {getReactComponent("https://leela-online-videos.s3.eu-north-1.amazonaws.com/%D0%A1%D0%BF%D0%B8%D1%81%D0%BE%D0%BA%D0%86%D0%BD%D0%B4%D0%B8%D0%B2%D1%96%D0%B4%D1%83%D0%B0%D0%BB%D1%8C%D0%BD%D0%B8%D1%85%D0%86%D0%B3%D1%80.mov")}

            <div style={{marginTop: "100px"}}><b>{t('editing')}</b></div>
            {getReactComponent("https://leela-online-videos.s3.eu-north-1.amazonaws.com/%D0%A0%D0%B5%D0%B4%D0%B0%D0%B3%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F%D0%86%D0%BD%D0%B4%D0%B8%D0%B2%D1%96%D0%B4%D1%83%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D1%96%D0%93%D1%80%D0%B8.mov")}

            <div style={{marginTop: "100px"}}><b>{t('invitingPlayer')}</b></div>
            {getReactComponent("https://leela-online-videos.s3.eu-north-1.amazonaws.com/IndividualGame_invite_PLayer.mp4")}

            <div style={{marginTop: "100px"}}><b>{t('gameField')}</b></div>
            {getReactComponent("https://leela-online-videos.s3.eu-north-1.amazonaws.com/IndivGame_GameField_small.mp4")}

            <div style={{marginTop: "100px"}}><b>{t('metaphoricCards')}</b></div>
            {getReactComponent("https://leela-online-videos.s3.eu-north-1.amazonaws.com/IndividualGame_MetCards_small.mp4")}

            <div style={{marginTop: "100px"}}><b>{t('record')}</b></div>
            {getReactComponent("https://leela-online-videos.s3.eu-north-1.amazonaws.com/IndivGane_VideoRecord_small.mp4")}
        </div>

    )
}

export default VideoComponent_IndividualGames
